import { motion, useReducedMotion } from "framer-motion";
import React from "react";
import { useIntl } from "../../utils/intl";
import CodeBlock from "../Molecules/blocks/CodeBlock";
import Image from "../Molecules/blocks/Image";
import Prose from "../Molecules/blocks/Prose";
import Intro from "../Molecules/Intro";
export function BlogEntry(param) {
    var title = param.title, lead = param.lead, content = param.content, author = param.author, date = param.date;
    var intl = useIntl();
    var formattedDate = intl.formatDate(date, {
        year: "numeric",
        month: "short",
        day: "numeric"
    });
    var avoidAnimation = useReducedMotion();
    return /*#__PURE__*/ React.createElement(motion.main, {
        id: "main-content",
        className: "flex-1 relative z-10 max-w-full bg-light-grey",
        initial: avoidAnimation ? {
            opacity: 1,
            x: 0
        } : {
            opacity: 0,
            x: -200
        },
        animate: {
            opacity: 1,
            x: 0
        },
        exit: avoidAnimation ? {
            opacity: 1,
            x: 0
        } : {
            opacity: 0,
            x: 200
        },
        transition: {
            type: "spring",
            mass: 0.35,
            stiffness: 75,
            duration: 0.3
        }
    }, /*#__PURE__*/ React.createElement(Intro, {
        textIsCenter: false,
        title: title,
        color: "turquoise",
        lead: lead,
        author: author,
        formattedDate: formattedDate
    }), /*#__PURE__*/ React.createElement("div", {
        className: "my-5 md:my-8 relative"
    }, content.map(function(block, index) {
        switch(block.__typename){
            case "BlockText":
                return /*#__PURE__*/ React.createElement(Prose, {
                    key: index,
                    content: block.content,
                    className: block.className
                });
            case "BlockCode":
                return /*#__PURE__*/ React.createElement(CodeBlock, {
                    key: index,
                    code: block.code,
                    language: block.language
                });
            case "BlockImage":
                return /*#__PURE__*/ React.createElement(Image, {
                    description: block.description,
                    alt: block.alt,
                    image: block.image,
                    key: index
                });
            case "BlockError":
                return /*#__PURE__*/ React.createElement("p", null, block.message);
        }
    })));
}
